/* unplugin-vue-components disabled */import { render } from "./FeaturedComponent.vue?vue&type=template&id=66d0c779&scoped=true"
import script from "./FeaturedComponent.vue?vue&type=script&lang=js"
export * from "./FeaturedComponent.vue?vue&type=script&lang=js"

import "./FeaturedComponent.vue?vue&type=style&index=0&id=66d0c779&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d0c779"]])

export default __exports__